var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgRotateCcw = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M2.74994154,8.26181532 L6.11577253,5.09226358 C9.16930063,2.03631735 13.9007336,1.36520163 17.7037314,3.46213788 C21.5067293,5.55907413 23.4643789,9.9184853 22.5050518,14.1540052 C21.5457248,18.389525 17.9007174,21.4799582 13.5653273,21.7335842 C9.22993723,21.9872102 5.24943875,19.342879 3.80277918,15.2481125 C3.66479778,14.8575565 3.86954993,14.4290922 4.26010592,14.2911108 C4.6506619,14.1531294 5.0791261,14.3578816 5.2171075,14.7484376 C6.44120407,18.2132401 9.80931816,20.450751 13.4777252,20.2361444 C17.1461322,20.0215378 20.2303692,17.4065559 21.0421075,13.8226545 C21.8538457,10.2387531 20.197373,6.55002053 16.9794517,4.77568986 C13.7615305,3.00135918 9.75801027,3.56922633 7.16044064,6.16843762 L3.89023401,9.24827507 L7.99994154,9.24827507 C8.4141551,9.24827507 8.74994154,9.58406151 8.74994154,9.99827507 C8.74994154,10.4124886 8.4141551,10.7482751 7.99994154,10.7482751 L2.0018715,10.7482751 C1.90149527,10.7485128 1.80119222,10.7287225 1.697523,10.6848067 C1.43392972,10.5685243 1.24994154,10.304886 1.24994154,9.99827507 L1.24994154,3.99827507 C1.24994154,3.58406151 1.58572798,3.24827507 1.99994154,3.24827507 C2.4141551,3.24827507 2.74994154,3.58406151 2.74994154,3.99827507 L2.74994154,8.26181532 Z"
  }));
};
export default SvgRotateCcw;